var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTablet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    fill: "none",
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.9588 0H2.0402C1.28889 0 0.684082 0.607754 0.684082 1.35848V18.6421C0.684082 19.3905 1.28889 20 2.0402 20H13.9588C14.7077 20 15.3155 19.3911 15.3155 18.6421V1.35848C15.3167 0.607754 14.7083 0 13.9588 0ZM8.00008 19.4911C7.55412 19.4911 7.19347 19.1304 7.19347 18.6851C7.19347 18.2391 7.55412 17.8779 8.00008 17.8779C8.44486 17.8779 8.80669 18.2391 8.80669 18.6851C8.80669 19.1304 8.44486 19.4911 8.00008 19.4911ZM13.9429 17.1713H2.05727V1.63205H13.9429V17.1713Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/tablet.8232df1207fde966913694f174ec79e4.svg";
export { ForwardRef as ReactComponent };